export default __webpack_public_path__ + "static/media/invoice-image.e0129d2e.png";